import { Grid } from "@material-ui/core"
import styled from "@emotion/styled"

export default styled(Grid)(
  {
    display: "flex",
    flexDirection: "row",
    direction: "row",
    justify: "center",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
  },
  props => ({
    display: props.display,
  })
)
